import api from "@/apis/TemplateAPI";
import Crud from "./crud-base";
var crud = new Crud("Template", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "TemplateID",
      code: "TemplateName",
      name: "TemplateName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
